const styles = (theme) => ({
  iconContainer: {
    width: 40,
    height: 40,
    position: 'absolute',
    zIndex: 10,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  hideBox: {
    display: 'none',
  },
  toggleIcon: {
    fill: theme.color.grey_75,
  },
  content: {
    alignItems: 'center',
    minHeight: 60,
    position: 'relative',
  },
  tree: {
    '& .MuiTreeItem-root.Mui-selected > .MuiTreeItem-content .MuiTreeItem-label, .MuiTreeItem-root:focus > .MuiTreeItem-content .MuiTreeItem-label': {
      backgroundColor: 'transparent',
    },
  },
  label: {
    backgroundColor: 'transparent',
    padding: '0 0 0 40px',
  },
  noPadding: {
    padding: '0',
  },
  topLevelPadding: {
    paddingLeft: theme.spacing(2.5),
  },
  group: {
    marginLeft: 40,
  },
});

export default styles;
